import { inject, Injectable } from '@angular/core';
import { HeaderLogoDto } from '@data/data/models/header-logo.dto';
import { HeaderRepository } from '@data/repositories/header.repository';
import { UseCase } from '@shared/helper';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GetHeaderLogoUsecase implements UseCase<string, HeaderLogoDto> {
    private readonly headerRepository = inject(HeaderRepository);

    execute(currentUrl: string): Observable<HeaderLogoDto> {
        return this.headerRepository.getHeaderLogo().pipe(
            map(resp => {
                const result = this.findMatchingConfig(currentUrl, resp);
                if (!result) {
                    throw new Error('No matching header logo configuration found.');
                }
                return result;
            })
        );
    }

    private findMatchingConfig(currentUrl: string, data: HeaderLogoDto[]) {
        return data.find(item => {
            const pattern = item.path.replace('*', '.*');
            const regex = new RegExp(pattern);
            return regex.test(currentUrl);
        });
    }
}